import React from 'react';
import PropTypes from 'prop-types';
import Card from '../Card';
import CardInner from '../CardInner';
import CardContent from '../CardContent';
import CardContentLink from '../CardContentLink';
import CardContentImage from '../CardContentImage';
import CardContentBody from '../CardContentBody';
import CardContentImagePlay from '../CardContentImagePlay';

/**
 * A component for displaying regular content
 */
function RegularCard({ width, href, className, linkTitle, target, alt, source, time, title, children }) {
  return (
    <Card type={'card'} width={width} link={!!href} className={className}>
      <CardInner>
        <CardContent>
          <CardContentLink href={href} title={linkTitle} target={target}>
            <CardContentImage alt={alt} source={source} ariaHidden={true}>
              {time && <CardContentImagePlay time={time} />}
            </CardContentImage>
            <span>{title}</span>
          </CardContentLink>
          <CardContentBody>{children}</CardContentBody>
        </CardContent>
      </CardInner>
    </Card>
  );
}

RegularCard.propTypes = {
  /**
   * The card width
   */
  width: PropTypes.string,
  /**
   * The card classes
   */
  className: PropTypes.string,
  /**
   * The card title
   */
  title: PropTypes.string,
  /**
   * The card link target
   */
  target: PropTypes.string,
  /**
   * The card link
   */
  href: PropTypes.string,
  /**
   * The card link title
   */
  linkTitle: PropTypes.string,
  /**
   * The card image source
   */
  source: PropTypes.string,
  /**
   * The card image alt text
   */
  alt: PropTypes.string,
  /**
   * The card time value
   */
  time: PropTypes.string,
  /**
   * The nested children
   */
  children: PropTypes.node
};

export default RegularCard;
